module.exports = __webpack_public_path__ + "img/nodata.28f1038e.png";